module.exports = __webpack_public_path__ + "img/artillery-wagon-base-11.731182fc.png";